import styled, { css } from 'styled-components/macro';

import P from 'components/elements/p';

import colors from 'styles/themes/colors';
import Box from 'components/elements/Box';

import { definitionLabel, definitionValue } from 'styles/base-classes';
import {
  Entity,
  TitleWrapper,
} from 'components/base/EntityItem/EntityItem.style';
import { RadioGroupTabsWrapper } from 'components/base/Tabs/Tabs';
import { Label } from 'components/base/RadioGroup/RadioGroup';

export const DiscIcon = styled(P)<any>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ backgroundColor }): string => backgroundColor};
`;

export const GenderLabel = styled(P)`
  ${definitionLabel};
`;

export const GenderValue = styled(P)`
  ${definitionValue};
`;

export const tooltipArrowStyle = `
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid ${colors.NightBlue};
`;

export const tooltipStyle = `
  display: none;
  position: fixed;
  height: 31px;
  align-items: center;
  justify-content: space-between;
  transform: translate(-50%, calc(-100% - 10px));
  padding: 15px;
  background-color: ${colors.NightBlue};
  color: ${colors.White};
  border-radius: 10px;
  font-size: 14px;
`;

export const BreakDownItemBox = styled(Box)`
  display: flex;
  flex-basis: 50%;
  margin: 0.75rem 0;
`;

export const ComparePieWrapper = styled(Box)`
  flex-direction: column;
  flex-basis: 45%;
  margin-bottom: 1rem;
`;

export const ComparePieSectionsWrapper = styled(Box)<any>`
  display: flex;
  align-items: center;
  ${ComparePieWrapper} {
    ${BreakDownItemBox} {
      margin: 0.25rem 0;
      ${GenderLabel} {
        margin-top: 0;
      }
    }
  }
  @media screen and (max-width: ${({ mediaScreenWidth }): string =>
      mediaScreenWidth ? mediaScreenWidth : '40em'}) {
    // CarouselView
    ${Entity}, ${TitleWrapper} {
      justify-content: center;
    }
  }
`;

export const PercentValue = styled('span')`
  font-family: 'Open Sans';
  font-size: 15px;
  color: ${colors.DeepBlue};
  font-weight: 600;
`;

export const SmallTableRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.LightGrey};
`;

export const GendersTabs = styled(Box)<{ isSmallScreen?: boolean }>`
  ${({ isSmallScreen }): any =>
    isSmallScreen &&
    css`
      ${RadioGroupTabsWrapper} {
        ${Label} {
          flex: auto;
        }
      }
    `}
`;

export const SubTitle = styled(Box)`
  font-size: 10px;
  color: ${colors.CasperGrey};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;

  @media screen and (max-width: 800px) {
    font-size: 13px;
  }
`;
